export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./request-contact.vue?vue&type=template&id=63cdb7d4&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/request-contact.vue?vue&type=template&id=63cdb7d4&
// module id = 1694
// module chunks = 0